import { useEffect, useMemo, useState } from 'react'

import { IPluginFieldOptions } from '@makyoapp/makyo-sdk/models/Plugins'
import { Field, Label, SelectDropdown, SelectDropdownProps } from '@makyoapp/makyo-ui'

import { RequirementFieldProps, RequirementLink } from './Requirements'

export type SelectFieldProps = RequirementFieldProps &
  Omit<SelectDropdownProps<IPluginFieldOptions>, 'onChange' | 'value' | 'options' | 'renderOption'> & {
    value?: string
  }

export default function SelectField({ requirement, onValue, value: initialValue }: SelectFieldProps) {
  // TODO: get current user language
  const lang = useMemo(() => 'en', [])

  const options = useMemo(() => requirement._Options, [requirement._Options])

  // ─── States ──────────────────────────────────────────────────────────────────
  const [value, setValue] = useState<IPluginFieldOptions>(options.find((o) => o._Key === initialValue) ?? options[0])

  // ─── Functions ───────────────────────────────────────────────────────
  const handleChange = (v: IPluginFieldOptions) => {
    setValue(v)
    onValue(v._Key)
  }

  // ─── Effects ─────────────────────────────────────────────────────────

  // effect for setting first option by default
  useEffect(() => {
    if (!initialValue && options && options.length > 0) {
      onValue(options[0]._Key)
    }
  }, [initialValue, options])

  return (
    <Field>
      <Label required={requirement._IsMandatory}>{requirement._Label[lang]}</Label>
      <SelectDropdown
        id={`plugin-requirement-${requirement._Key}`}
        options={options}
        renderOption={(option) => option._Name[lang]}
        value={value}
        onChange={(v) => handleChange(v)}
      />
      <RequirementLink requirement={requirement} />
    </Field>
  )
}
